import { render, staticRenderFns } from "./zContent.vue?vue&type=template&id=04a84aaa&scoped=true"
import script from "./zContent.vue?vue&type=script&lang=js"
export * from "./zContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a84aaa",
  null
  
)

export default component.exports